// @flow
import React from "react";
import { windowOpen } from "../../../../services/helpers";

export const pageObj = {
  pageName: "View Ticket",
  betaPage: false
};

export const editOptions = {
  INTERACTION_COUNT: "INTERACTION_COUNT",
  PRIORITY: "PRIORITY",
  STATUS: "STATUS",
  ASSIGNEE: "ASSIGNEE",
  ASSIGN_TO_ME: "ASSIGN_TO_ME",
  STATUS_CLOSED: "STATUS_CLOSED",
  CHANGE_CC: "CHANGE_CC",
  SEVERITY: "SEVERITY"
};

export const toastrMessages = {
  INTERACTION_COUNT: "Are you sure you want to increase the interaction count?",
  PRIORITY: "Are you sure you want to change the priority?",
  STATUS: "Are you sure you want to change the status?",
  ASSIGNEE: "Are you sure you want to change the assignee?",
  SEVERITY: "Are you sure you want to change the severity?"
};

export const ticketStatusOptions = {
  NEW: "NEW",
  IN_PROGRESS: "IN_PROGRESS",
  ESCALATED: "ESCALATED",
  CLOSED: "CLOSED",
  REOPENED: "REOPENED"
};

export const ticketPriorityOptions = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH"
};

export const radioOptions = {
  Client_Communication: "Send Email",
  Internal_Note: "Comment"
};

export const renderOptions = {
  DISABLED: "DISABLED",
  ENABLED: "ENABLED",
  HIDDEN: "HIDDEN"
};

export const analyticsEventList = {
  render: {
    event_category: "viewticket",
    event_action: "render",
    event_label: "Open ViewTicket"
  },
  clientCommunication: {
    event_category: "viewticket",
    event_action: "event",
    event_label: "Client Communication used"
  },
  editTicketEvent: {
    event_category: "viewticket",
    event_action: "event",
    event_label: "Editing ticket details"
  }
};

export const goToViewTicket = (rowData: Object) => {
  // eslint-disable-next-line no-console
  console.log("rowData", rowData);
  if (!rowData || !rowData.id) {
    return;
  }
  windowOpen(`/#/viewticket/${rowData.id}`, "_blank");
};

export const goToCreateTicket = (rowData: Object) => {
  // eslint-disable-next-line no-console
  console.log("rowData", rowData);
  if (!rowData || !rowData.id) {
    return;
  }
  windowOpen(`/#/createticket/${rowData.id}`, "_blank");
};

export const viewChildTicketTableConfig = {
  columns: [
    {
      Header: "Ticket ID",
      accessor: "id",
      className: "cn-highlight",
      Cell: (row: Object) => (
        <div onClick={() => goToViewTicket(row.original)}>
          {row.original.id}
        </div>
      )
    },
    {
      Header: "Status",
      accessor: "status"
    }
  ],
  className: "zoomTableLegacyWrapper",
  noDataText: "No data found",
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: "calc(100vh - 22rem)" }
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/viewTicket/viewTicketHelper.js